export default __webpack_public_path__ + "static/media/Timer.6c5fdd11.svg";